"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDate = void 0;
const date_fns_1 = require("date-fns");
const types_shared_1 = require("../types.shared");
const time_1 = require("../helpers/time");
const date_1 = require("../helpers/date");
const validateDate = ({ userState, filteredLocations, }) => {
    if (!(userState === null || userState === void 0 ? void 0 : userState.location)) {
        return {
            result: (0, types_shared_1.error)({ code: 'NO_LOCATION' }),
            newLocations: filteredLocations,
        };
    }
    if (!(userState === null || userState === void 0 ? void 0 : userState.date) && !userState.time) {
        return {
            result: (0, types_shared_1.error)({ code: 'NO_DATE' }),
            newLocations: filteredLocations,
        };
    }
    const newDate = (0, date_1.convertDate)(userState.date);
    if (!newDate || newDate === null) {
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_DATE' }),
            newLocations: filteredLocations,
        };
    }
    const weekday = (0, date_fns_1.getISODay)(newDate);
    if (isNaN(newDate.getTime())) {
        return {
            result: (0, types_shared_1.error)({ code: 'INVALID_DATE' }),
            newLocations: filteredLocations,
        };
    }
    if ((0, date_1.isBeforeNotSame)(new Date(), newDate)) {
        return {
            result: (0, types_shared_1.error)({ code: 'DATE_PAST' }),
            newLocations: filteredLocations,
        };
    }
    const newSelectedVendorLocations = filteredLocations.filter((location) => {
        var _a, _b;
        if (!location)
            return false;
        if ((_a = location === null || location === void 0 ? void 0 : location.closingDates) === null || _a === void 0 ? void 0 : _a.closedWeekdays.includes(weekday))
            return false;
        return !((_b = location === null || location === void 0 ? void 0 : location.closingDates) === null || _b === void 0 ? void 0 : _b.closedDates.some((closedDate) => (0, date_fns_1.isSameDay)(newDate, new Date(closedDate))));
    });
    if (!newSelectedVendorLocations.length) {
        return {
            result: (0, types_shared_1.error)({ code: 'DATE_CLOSED' }),
            newLocations: newSelectedVendorLocations,
        };
    }
    const result = (0, time_1.checkMaxHeadCountAdjustment)(newDate, userState, newSelectedVendorLocations);
    if (result) {
        return result;
    }
    return {
        result: (0, types_shared_1.ok)(),
        newLocations: newSelectedVendorLocations,
    };
};
exports.validateDate = validateDate;
